import { createStash } from "@latticexyz/stash/internal";
import config from "contracts/mud.config";

const { MatchConfig, Match, MatchCounter } = config.namespaces[""].tables;

export const tables = {
  MatchConfig,
  Match,
  MatchCounter,
};

export const stashConfig = {
  namespaces: {
    "": {
      tables,
    },
  },
};

export const stash = createStash(stashConfig);

(window as any).stash = stash;
